<form [formGroup]='formGroup'
      class='widget'>
  <div class='form-group'>
    <pt-input-label
      *ngIf='label'
      [inputId]='inputId'
      [isRequired]='isRequired'
      [label]='label'
      style='display: contents'
    ></pt-input-label>
    <input [class.is-invalid]='isChanged && formGroup.invalid'
           [id]='inputId'
           aria-describedby='ptWInputHelp'
           autocomplete='off'
           class='form-control form-control-sm'
           formControlName='value'
           placeholder='{{placeholder}}'
           type='tel'>
    <small [innerHTML]='help'
           class='form-text text-muted' id='ptWInputHelp_{{controlName}}'>
    </small>
  </div>
</form>
